import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
	count: 0,
	data: [],
	projects: [],
	currentProject: {},
	pages: 1,
	totalEmps: 0,
	totalPoses: 0,
	totalRoutes: 0,
	limit: JSON.parse(localStorage.getItem('pageLimit') as string) || 10,
	projectsInputValues: {
		managers: [],
	},
};
export const projectSlice = createSlice({
	name: 'projects',
	initialState,
	reducers: {
		reducerGetProjects: (state: Draft<any>, action: PayloadAction<any>) => {
			state.count = action.payload.data.count;
			state.data = action.payload.data.data;
			state.pages = action.payload.data.pages;
			state.totalEmps = action.payload.data.totalEmps;
			state.totalPoses = action.payload.data.totalPoses;
			state.totalRoutes = action.payload.data.totalRoutes;
			state.projects = action.payload.data.data.map((el: any) => el.project);
		},
		reducerGetProjectsFilters: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.projectsFilters = action.payload;

			state.managersOptions = action.payload.managers?.map((option: any) => ({
				value: option.id,
				label: option.name,
			}));
		},
		reducerProjectsInputValues: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.projectsInputValues = action.payload;
		},
		reducerSetCurrentProject: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.currentProject = action.payload;
		},
		reducerProjectClearInputValues: (
			state: Draft<any>,
		) => {
			state.projectsInputValues = { managers: [], };
		}
	},
});

export const {
	reducerGetProjects,
	reducerGetProjectsFilters,
	reducerProjectsInputValues,
	reducerSetCurrentProject,
	reducerProjectClearInputValues
} = projectSlice.actions;

export default projectSlice.reducer;
